<template>
	<div>

		<div v-if="sizes.length > 0">
			<p class="pb-s10 text-t14 m_1200:text-t16">Izaberite veličinu:</p>

			<ul class="flex gap-s5 flex-wrap mx-auto pb-s10 w-fit justify-center m_800:pb-s15 m_1000:justify-start m_1000:mx-0 m_1200:gap-s10 m_1200:pb-s20" id="js_product_sizes">
				<li v-for="(size, index) in sizes" :key="index">
					<button v-if="sizes.length === 1" type="button" @click="getSelectedSize(size)"
                  class="px-s15 py-s10 text-t12 grid place-items-center border border-black cursor-pointer bg-black text-white m_1000:transition-colors m_1000:duration-200 m_1200:px-s20 m_1200:py-s10 m_1200:text-t14 js_get_selected_size">
						{{ selectOneSize() }} {{ size }}
					</button>
					<button v-else type="button" @click="getSelectedSize(size)"
                  class="px-s15 py-s10 text-t12 grid place-items-center border border-black cursor-pointer m_1000:hover:bg-black m_1000:hover:text-white m_1000:transition-colors m_1000:duration-200 m_1200:px-s20 m_1200:py-s10 m_1200:text-t14 js_get_selected_size">
						{{ size }}
					</button>
				</li>
			</ul>
		</div>

    <!-- Choose size error desktop -->
		<p v-if="message && selectedSize === ''" class="text-red text-t14 font-medium pb-s10 hidden m_1000:block">{{ message }}</p>

		<div v-if="same.length > 0" class="hidden m_1000:block">
			<p class="pb-s10 text-t14 m_1200:text-t16">Dostupne boje:</p>
			<div class="flex gap-s10 mb-s30 w-fit mx-auto m_1000:mx-0 m_1200:mb-s20">
				<a v-for="(item, index) in same" :href="item.path" :key="index">
					<img :src="item.thumbnail_small" alt="dostupne boje" class="w-s55 m_1200:w-s65" width="120" height="182" loading="lazy">
				</a>
			</div>
		</div>

    <!-- Choose size error mobile -->
		<p v-if="message && selectedSize === ''" class="text-red text-t14 font-medium m_1000:hidden">{{ message }}</p>

		<p v-if="this.underwear" style="color: red">Ovaj proizvod ne može biti zamenjen/vraćen iz higijenskih razloga</p>

		<div class="w-fit mx-auto grid gap-s10 pt-s10 m_580:flex m_580:gap-s10 m_580:items-center m_800:pt-s15 m_1000:mx-0 m_1200:pt-s20">
			<div class="w-s200 m_1000:w-fit">
				<add-to-cart
					:size="selectedSize"
					:product="product"
					:price="price"
				>
				</add-to-cart>
			</div>

      <button type="button" id="js_find_store" @click="checkWarehouses()" class="w-s200 grid items-center bg-white text-t14 text-black py-s10 px-s20 uppercase border border-black m_1000:hover:border-light-gray m_1000:hover:bg-light-gray m_1000:transition-colors m_1000:duration-200 m_1000:w-fit m_1200:text-t16 m_1200:px-s40 m_1200:min-w-s200">
        Pronađi u radnji
      </button>
		</div>

		<div class="store_el" id="js_store_el">
			<div class="grid m_1000:block" v-if="warehouses.length > 0">
				<template v-for="(warehouse) in warehouses">
					<template v-if="warehouse.title === 'Magacin' && warehouses.length === 1">
						<div class="grid grid-flow-row-dense mt-s20">
							<p> Ovaj proizvod je dostupan samo online</p>
						</div>
					</template>
					<template v-else-if="warehouse.title !== 'Magacin'">
						<div class="grid grid-flow-row-dense justify-items-center mt-s20 pb-s20 border-b border-light-gray m_650:grid-flow-col-dense m_1000:justify-start gap-s20">
							<div class="grid content-start">
								<img :src="warehouse.img" alt="movem radnja" width="210" height="129" class="min-w-[235px]" loading="lazy">
								<!-- <div class="w-s35 mx-auto place-self-center text-light-gray cursor-pointer m_1000:hover:text-black m_1000:transition-colors m_1000:duration-200 m_1000:mt-s20">
									<div class="js_availability_map size-s35">
										<location-icon></location-icon>
									</div>
								</div> -->
							</div>
							<div>
								<p class="font-medium">{{ warehouse.title }}</p>
								<p v-if="warehouse.store">{{ warehouse.store }}</p>
								<p>{{ warehouse.address }}</p>
								<p>&nbsp;</p>
								<p class="font-medium">Radno vreme</p>
								<p>radni dani: {{ warehouse.working_hours.week_days }}</p>
								<p>subota: {{ warehouse.working_hours.saturday }}</p>
								<p>nedelja: {{ warehouse.working_hours.sunday }}</p>
								<p>&nbsp;</p>
								<p>{{ warehouse.contact.mob }}</p>
								<p v-if="warehouse.contact.tel">{{ warehouse.contact.tel }}</p>
								<p>{{ warehouse.contact.email }}</p>
							</div>
						</div>
					</template>
				</template>
			</div>
		</div>

	</div>


</template>

<script>
import LocationIcon from '../svg/LocationIcon.vue';

export default {
	name: "ProductCartItems",
  comments: {
    LocationIcon,
  },

	props: [
		'sizes',
		'price',
		'same',
		'product',
		'underwear'
	],

	data: function () {
		return {
			selectedSize: '',
			message: '',
			warehouses: []
		}
	},

	methods: {
		getSelectedSize(size) {
			this.selectedSize = size;
		},

		checkWarehouses() {

			if (this.selectedSize) {

				axios.post('/provera', {id: this.product.id, size: this.selectedSize})
					.then(response => {

						if (response.data.warehouses !== null) {

							this.warehouses = response.data.warehouses;
							this.message = null;
						} else {

							this.$toasted.global.toastError({ message: 'Proizvod u izabranoj veličini nije na stanju' });
						}
					})
					.catch(error => {

						console.log(error);
					})
			} else {
				this.message = 'Izaberite veličinu.'
			}
		},

		/**
		 * Select size when there is only 1 size availabile.
		 */
		selectOneSize() {
			this.selectedSize = this.sizes[0];
		}
	}
}
</script>